<template>
    <div>


        <el-form-item v-if="type === 'form'" v-for="settingItem in value" :label="settingItem.name"
                      :prop="settingItem.key" class="fb-form">
            <el-checkbox-group v-if="settingItem.type === 'CHECKBOX'" v-model="settingItem.value">
                <el-checkbox v-for="item in settingItem.candidates" :label="item.value" :key="item.value">{{item.name}}
                </el-checkbox>
            </el-checkbox-group>

            <el-input v-if="settingItem.type === 'INPUT'" v-model="settingItem.value"></el-input>


            <el-select v-if="settingItem.type === 'SELECT'" v-model="settingItem.value">
                <el-option
                        v-for="item in settingItem.candidates"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>

        </el-form-item>

        <el-table
                v-if="type === 'table'"
                :data="tableData"
                :header-cell-style="headerCellStyle"
                border
                style="width: 100%">




            <el-table-column
                    v-for="(settingItem,index) in tableData[0]"
                    :label="settingItem.name"
            >
                <template slot-scope="scope">


                    <template v-if="!readonly">

                        <el-checkbox-group v-if="tableData[0][index].type === 'CHECKBOX'" v-model="tableData[0][index].value">
                            <el-checkbox v-for="item in tableData[0][index].candidates" :label="item.name" :key="item.name">
                                {{item.name}}
                            </el-checkbox>
                        </el-checkbox-group>

                        <el-input v-if="tableData[0][index].type === 'INPUT'" v-model="tableData[0][index].value" style="max-width: 200px;"></el-input>


                        <el-select v-if="tableData[0][index].type === 'SELECT'" v-model="tableData[0][index].value">
                            <el-option
                                    v-for="item in tableData[0][index].candidates"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>

                    </template>

                    <template v-else>


                        <span v-if="tableData[0][index].type === 'INPUT'" >{{tableData[0][index].value}}</span>
                        <span v-if="tableData[0][index].type === 'CHECKBOX'" >{{tableData[0][index].candidates.find(e=> e.value === tableData[0][index].value).name}}</span>
                        <span v-if="tableData[0][index].type === 'SELECT'" >{{tableData[0][index].candidates.find(e=> e.value === tableData[0][index].value).name}}</span>


                    </template>


                </template>
            </el-table-column>
        </el-table>




        <input type="hidden" v-model="value">
    </div>
</template>

<script>
    export default {
        name: "DiyForm",
        props: {
            value: {
                type: Object
            },
            readonly: {
                type: Boolean,
                default:function () {
                    return false;
                }
            },
            headerCellStyle:{
                type: Object,
                default:function () {
                    return {};
                }
            },
            type: {
                type: String,
                default: function () {
                    return "form"
                }
            }
        },
        data(){
           return {
               tableData:[]
           }
        },
        watch: {

            value: {
                deep: true,
                handler: function () {
                    this.tableData[0] = this.value
                    this.$emit('input',this.value);
                }
            }
        },
        created() {
            this.tableData[0] = this.value;
        }
    }
</script>

<style scoped>

</style>